import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import { DashboardStyle, DashboardStyleResponse } from '../interfaces/dashboardStyle.interface';

/** The caller's own Tiles / Thread choice, saved on the server per user and institution. */
export const DashboardStyleService = {
    get: async (institutionId: string): Promise<DashboardStyleResponse> => {
        const res = await axios.get(ENDPOINTS.DASHBOARD.STYLE(institutionId), { headers: AuthService.getAuthHeader() });
        return res.data;
    },

    save: async (institutionId: string, style: DashboardStyle): Promise<DashboardStyleResponse> => {
        const res = await axios.put(ENDPOINTS.DASHBOARD.STYLE(institutionId), { style }, { headers: AuthService.getAuthHeader() });
        return res.data;
    },
};
